import React, { useContext, useState } from "react";
import { Route } from "react-router-dom";
import application_contants from "../constants/application_contant";

import Login from "../customPages/Login/Login";

import { AuthContext } from "../context/AuthProvider";

import AddPatient from "../customPages/Patient";
import Patientslist from "../customPages/HomeScreen";
import Devices from "../customPages/Devices";
import Hospital from "../customPages/Hospital";
import TestData from "../customPages/visits";
import Users from "../customPages/Users";
// import Login from "../customPages/LoginScreen";
import VisitDetails from "../customPages/VisitDetails";

const RoutesComponent = (props) => {
  const appContext = useContext(AuthContext);
  const [authenticated, setAuthenticated] = useState(AuthContext.isLogin);

  React.useEffect(() => {
      const handleAuthenticated = async () => {
          await setAuthenticated(appContext ? appContext[0].isLoggedIn : false)
      }
      handleAuthenticated();
  }, [appContext]);

  return (
    <div>
      <Route
        exact
        path={application_contants.LANDING}
        component={Login}
        {...props}
      />
      <Route exact path="/Patients" component={AddPatient} {...props} />
      <Route exact path="/Home" component={Patientslist} {...props} />
      <Route exact path="/test" component={TestData} {...props} />
      <Route exact path="/devices" component={Devices} {...props} />
      <Route exact path="/Hospital" component={Hospital} {...props} />
      <Route exact path="/users" component={Users} {...props} />
      <Route exact path="/visitdetails" component={VisitDetails} {...props} />
    </div>
  );
};

export default RoutesComponent;
